<app-search [showHideForm]="showForm" (childEvent)="transferVal($event)"></app-search>
<div  class="container" style="max-width: 1240px">
    <div class="row">
    </div>
    <div>
      <h5 *ngIf="flightLists" class="card-title">Flights Between: <span> {{timeObj.timeBeg + ',' + ' ' + timeObj.dateBeg + ' ' + 'and' + ' ' + timeObj.timeEnd + ',' + ' ' + timeObj.dateEnd}}</span></h5>
      <div class="row">
        <!-- <div *ngFor="let flightDetail of flightLists" class="col-md-9 ms-sm-auto col-lg-10 px-md-4"> -->
        <div *ngFor="let flightDetail of flightLists" id="card-border" class="col-md-9 sm col-lg-3 md-4 mb-4">
          <div class="card" style="width: 18rem;">
              <img class="card-img-top" src="..." alt="Card image cap">
              <div class="card-body shadow bg-white rounded">
                  <p class="d-inline-block w-50 mb-3 card-text">Plane Call Sign:</p><span *ngIf="flightDetail.callsign; else showDat" class="border border-warning border-2 p-1 rounded">{{flightDetail.callsign}}</span>
                  <p class="d-inline-block w-50 mb-3 card-text w-5">Departure Date: </p><span class="border border-info border-2 p-1 rounded">{{flightDetail.firstSeen * 1000 | date}}</span>
                  <p class="d-inline-block w-50 mb-3 card-text">Departure Time:  </p><span class="border border-primary border-2 p-1 rounded">{{flightDetail.firstSeen * 1000 | date:'h:mm a z'}}</span>
                  <p class="d-inline-block w-50 mb-3 card-text">Arrival Date:</p><span class="border border-info border-2 p-1 rounded"  >{{flightDetail.lastSeen * 1000 | date}}</span>
                  <p class="d-inline-block w-50">Arrival Time: </p><span class="border border-primary border-2 p-1 rounded">{{flightDetail.firstSeen * 1000 | date:'h:mm a z'}}</span>
                  <p class="card-text"></p>
                  <ng-template #showDat>
                    <span class="border border-warning border-2 p-1 rounded" id="callsign">N/A</span>
                  </ng-template>
              </div>
          </div>
        </div>
      </div>
      <div *ngIf="!flightLists" class="d-block ml-10">
              <div class="d-flex justify-content-center">
                <div class="spinner-border" style="width: 5rem; height: 5rem;" role="status">
                  <span class="sr-only"></span>
                </div>
              </div>
      </div>
    </div>
  </div>